import { GENERAL_PREBID_MODULES } from 'features/globalSetup/pages/Prebid/Modules/Gneral/GeneralList/constants'
import { PrebidModule } from 'features/globalSetup/types/prebidModule'
import { WorkspaceBidder } from '../schemas/editPaapiSchema'

export const isPAAPIModule = (prebidModuleName: PrebidModule['name']): boolean =>
  prebidModuleName === GENERAL_PREBID_MODULES.PAAPI.name

export const mapBidderIdsToCodes = (
  bidderIds: WorkspaceBidder['id'][],
  metaWorkspaceBidders: WorkspaceBidder[],
): WorkspaceBidder['bidderCode'][] =>
  bidderIds.map((bidderId: WorkspaceBidder['id']): WorkspaceBidder['id'] => {
    const metaWorkspaceBidder: undefined | WorkspaceBidder = metaWorkspaceBidders.find(
      (workspaceBidder: WorkspaceBidder): boolean => workspaceBidder.id === bidderId,
    )
    if (metaWorkspaceBidder === undefined) {
      throw Error('Related meta Workspace Bidder should exists.')
    }

    return metaWorkspaceBidder.bidderCode
  })
